import PopupTemplate from "@arcgis/core/PopupTemplate";
export function showMapPopupTemplate(popupSettings) {
    let title = popupSettings.popupTitle;
    popupSettings.data.popupTemplate = new PopupTemplate({
        title: title,
        content: popupSettings.popupContent(popupSettings.data),
        actions: [popupSettings.actions],
        outFields: ["*"]
    });
    popupSettings.view.popup.open({
        features: [popupSettings.data],
        location: popupSettings.mapPoint
    });
}
